export default "__VITE_ASSET__CHv5YU8T__"